import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { HelpModal } from './views/HelpModal';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<HelpModal />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.HelpModal)
	.build();

export default Layout;
